import React, { ReactNode } from "react";
import styled from "styled-components";
import { getHorizontalGap, getVerticalGap } from "../../styles";
import FadeImage from "../../components/FadeImage/FadeImage";
import Typography from "../Typography/Typography";

const IMAGE_SIZE = 268;
const IMAGE_SIZE_MOBILE = 168;

const Root = styled.div`
  padding-top: 158px;
  padding-bottom: 181px;
  margin: 0 auto;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-top: 58px;
    padding-bottom: 81px;
  }
`;

const InfoBoxWrapper = styled.div`
  width: 100%;
  margin-bottom: 32px;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: ${IMAGE_SIZE}px;
  height: ${IMAGE_SIZE}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: ${IMAGE_SIZE_MOBILE}px;
    height: ${IMAGE_SIZE_MOBILE}px;
  }
`;

const Heading = styled(Typography)`
  margin-top: 36px;
`;

const Description = styled(Typography)`
  margin-top: 8px;
  white-space: pre-wrap;
  max-width: 802px;
`;

const Buttons = styled.div`
  margin-top: 36px;
  display: flex;
  ${getHorizontalGap("28px")};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    align-self: stretch;
    flex-direction: column;
    ${getHorizontalGap("0")};
    ${getVerticalGap("10px")};
  }
`;

interface IProps {
  alertBox?: ReactNode;
  imageSrc?: string;
  title?: string | ReactNode;
  description?: string | ReactNode;
  actions?: ReactNode;
  className?: string;
}

const ConfirmScreen = ({
  imageSrc,
  title,
  description,
  actions,
  alertBox,
  className,
}: IProps) => {
  return (
    <Root className={`main-container ${className}`}>
      {alertBox && <InfoBoxWrapper>{alertBox}</InfoBoxWrapper>}
      {imageSrc && (
        <ImageWrapper>
          <FadeImage src={imageSrc} objectFit="contain" />
        </ImageWrapper>
      )}
      {title && (
        <Heading
          heading
          weight="500"
          size="md"
          align="center"
          fontFamily="Poppins"
        >
          {title}
        </Heading>
      )}
      {description && (
        <Description secondary size="lg" align="center">
          {description}
        </Description>
      )}
      {actions && <Buttons>{actions}</Buttons>}
    </Root>
  );
};

export default ConfirmScreen;
